import { api } from './api';
import { createLiveCapabilitiesStore } from './liveCapabilities';

/**
 * CORE-817 — the app-wide capability store, wired to the real capability API.
 * One instance for the whole app (mirrors the single flags poller in
 * `useFeatureFlags`): all `useLiveCapabilities` consumers share its cache and
 * subscriber set. Kept in its own module so non-React call sites (e.g. the
 * gamification level-up handler) can invalidate rights without importing a
 * hook.
 *
 * The fetcher ignores its `userId` argument — the API derives the caller from
 * the auth header — but the store keys the cache by that id so a switched
 * account never reads the previous user's rights.
 */
export const liveCapabilitiesStore = createLiveCapabilitiesStore(() =>
  api.getCreatorCapabilities(),
);

/**
 * Drop cached Live capabilities so the next read re-fetches. Call after a
 * level-up (rights widen without a relogin) or on logout (a foreign account's
 * rights must not survive). No `userId` → clears every entry, which is the
 * safe default when the caller does not have the id at hand.
 */
export function invalidateLiveCapabilities(userId?: string | null): void {
  liveCapabilitiesStore.invalidate(userId ?? null);
}
